import styles from "./PageHeader.module.css";

/**
 * Compact page opener. Carries the eyebrow, title and lead so inner
 * pages start with content instead of an empty band.
 */
export default function PageHeader({ eyebrow, title, lead, tone = "light" }) {
  return (
    <div className={`${styles.header} ${tone === "dark" ? styles.dark : ""}`}>
      <div className="u-shell">
        <p className={`u-eyebrow ${styles.eyebrow}`}>{eyebrow}</p>
        <h1 className={styles.title}>{title}</h1>
        {lead && <p className={styles.lead}>{lead}</p>}
      </div>
    </div>
  );
}
